// extracted by mini-css-extract-plugin
module.exports = {"productEditPageButton":"product-edit-page__button-44e"};